import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue, set, remove, push } from "firebase/database";
import app from "../../../firebaseConfig";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

const PersonalDialog = () => {
  const [personal, setPersonal] = useState([]);
  const [openPersonal, setOpenPersonal] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [editStates, setEditStates] = useState({});
  const [editedData, setEditedData] = useState({});
  const [newEmpleado, setNewEmpleado] = useState({ nombre: "", celular: "" });

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
const [selectedToDelete, setSelectedToDelete] = useState(null);


  const db = getDatabase(app);

  useEffect(() => {
    const db = getDatabase(app);
    const personalRef = ref(db, "nature/Awoo/Control/Personal");
  
    onValue(personalRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const lista = Object.entries(data).map(([key, value]) => ({
          id: key,
          nombre: value.nombre,
          celular: value.celular
        }));
        setPersonal(lista);
      } else {
        setPersonal([]); // No hay personal
      }
    });
  }, []);
  

  const handleEdit = (id, field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
    setEditStates((prev) => ({ ...prev, [id]: true }));
  };

  const handleSaveChanges = (id) => {
    const refEmpleado = ref(db, `nature/Awoo/Control/Personal/${id}`);
    set(refEmpleado, {
      nombre: editedData[id].nombre,
      celular: editedData[id].celular,
    });
    setEditStates((prev) => ({ ...prev, [id]: false }));
  };

  const handleDelete = (id) => {
    const refEmpleado = ref(db, `nature/Awoo/Control/Personal/${id}`);
    remove(refEmpleado);
  };

  const handleAddEmpleado = () => {
    const refPush = push(ref(db, "nature/Awoo/Control/Personal"));
    set(refPush, {
      nombre: newEmpleado.nombre,
      celular: newEmpleado.celular,
    });
    setNewEmpleado({ nombre: "", celular: "" });
    setOpenAddDialog(false);
  };

  return (
    <>
      {/* Botón Personal */}
      <div
        onClick={() => setOpenPersonal(true)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "5px",
          backgroundColor: "#72c21b",
          borderRadius: "10px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          width: "110px",
          height: "25px",
          cursor: "pointer",
        }}
      >
        <strong style={{ color: "#fff", fontSize: "14px" }}>🎯 Personal</strong>
      </div>

      {/* Modal principal */}
      <Modal open={openPersonal} onClose={() => setOpenPersonal(false)} center>
        <h3 style={{ textAlign: "center" }}>📋 Personal</h3>

        <div style={{ maxHeight: "400px", overflowY: "auto", marginBottom: "10px", width:"300px" }}>
          {personal.map((p) => {
            const isEditing = editStates[p.id];
            const edited = editedData[p.id] || {};
            return (
              <div
                key={p.id}
                style={{
                  backgroundColor: "#f2f2f2",
                  borderRadius: "8px",
                  padding: "10px",
                  marginBottom: "10px",
                  position: "relative",
                }}
              >
                {/* Botón eliminar */}
                <button
                  onClick={() => {
                    setSelectedToDelete(p);
                    setShowConfirmDialog(true);
                  }}                  
                  style={{
                    position: "absolute",
                    top: "-1px",
                    left: "-1px",
                    background: "#ff5c5c",
                    border: "none",
                    color: "#fff",
                    borderRadius: "50%",
                    width: "22px",
                    height: "22px",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>

                {/* Nombre y celular */}
                <div style={{ marginTop:"10px",display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    {isEditing ? (
                      <>
                        <input
                          type="text"
                          value={edited.nombre}
                          onChange={(e) => handleEdit(p.id, "nombre", e.target.value)}
                          placeholder="Nombre"
                          style={{ marginBottom: "5px", width: "100%" }}
                        />
                        <input
                          type="text"
                          value={edited.celular}
                          onChange={(e) => handleEdit(p.id, "celular", e.target.value)}
                          placeholder="Celular"
                          style={{ width: "100%" }}
                        />
                      </>
                    ) : (
                      <>
                        <div><strong>{p.nombre}</strong></div>
                        <div>{p.celular}</div>
                      </>
                    )}
                  </div>

                  {/* Botón editar */}
                  <button
                    onClick={() =>
                      isEditing
                        ? handleSaveChanges(p.id)
                        : handleEdit(p.id, "nombre", p.nombre) || handleEdit(p.id, "celular", p.celular)
                    }
                    style={{
                      marginLeft: "10px",
                      background: isEditing ? "#4caf50" : "#ccc",
                      border: "none",
                      borderRadius: "5px",
                      padding: "5px 8px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    {isEditing ? "💾" : "✏️"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Barra inferior con botón agregar */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px",
            borderTop: "1px solid #ddd",
          }}
        >
          <button
            onClick={() => setOpenAddDialog(true)}
            style={{
              background: "#72c21b",
              color: "#fff",
              border: "none",
              padding: "8px 12px",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            ➕ Agregar
          </button>
        </div>
      </Modal>

      {/* Modal para agregar nuevo empleado */}
      <Modal open={openAddDialog} onClose={() => setOpenAddDialog(false)} center>
        <h3>➕ Nuevo Empleado</h3>
        <input
          type="text"
          placeholder="Nombre"
          value={newEmpleado.nombre}
          onChange={(e) => setNewEmpleado({ ...newEmpleado, nombre: e.target.value })}
          style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
        />
        <input
          type="text"
          placeholder="Celular"
          value={newEmpleado.celular}
          onChange={(e) => setNewEmpleado({ ...newEmpleado, celular: e.target.value })}
          style={{ width: "100%", padding: "8px" }}
        />
        <div style={{ textAlign: "center", marginTop: "15px" }}>
          <button
            onClick={handleAddEmpleado}
            style={{
              background: "#72c21b",
              color: "#fff",
              border: "none",
              padding: "8px 20px",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Guardar
          </button>
        </div>
      </Modal>

      <Modal open={showConfirmDialog} onClose={() => setShowConfirmDialog(false)} center>
  <h4 style={{ textAlign: "center", marginBottom: "10px" }}>¿Eliminar empleado?</h4>
  <p style={{ textAlign: "center" }}>
    ¿Estás seguro de eliminar a <strong>{selectedToDelete?.nombre}</strong>?
  </p>
  <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "15px" }}>
    <button
      onClick={() => {
        handleDelete(selectedToDelete.id);
        setShowConfirmDialog(false);
      }}
      style={{
        background: "#ff5c5c",
        color: "#fff",
        border: "none",
        padding: "8px 16px",
        borderRadius: "5px",
        cursor: "pointer",
      }}
    >
      Sí, eliminar
    </button>
    <button
      onClick={() => setShowConfirmDialog(false)}
      style={{
        background: "#ccc",
        color: "#333",
        border: "none",
        padding: "8px 16px",
        borderRadius: "5px",
        cursor: "pointer",
      }}
    >
      Cancelar
    </button>
  </div>
</Modal>

    </>
  );
};

export default PersonalDialog;
